import useSWR from "swr";
import { getProticoClient } from "../utils/api";
import { useWeb3Auth } from "./useWeb3Auth";
import { useWhiteboardRoom } from "./useWhiteboardRoom";

const rewardFetcher = async (domain: string) => { return getProticoClient().engagement.getReward(domain) };
const useReward = () => {
  const { address, isProticoAuthenticated } = useWeb3Auth();
  const { roomDomain } = useWhiteboardRoom(); 

  const { data, error } = useSWR(
    isProticoAuthenticated ? [roomDomain] : null,
    rewardFetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: false,
    }
  );

  return {
    reward: data ?? {
      address: "",
      referral: {
        count: 0,
      },
      first_mover: {
        count: 0,
      },
      days_of_use: 0,
      if_firstmsgsent: false,
      if_firstnftsent: false,
      chat_level: 0,
      experience: 0,
      total: 0,
      daily_login: false,
      daily_message: false,
      daily_reaction: false,
      daily_response: false,
      daily_ad_click: false,
      daily_poll: false,
      daily_trending_room: false,
      daily_join_small_apps: false,
      daily_win_small_apps: false,
      daily_lobby_msg_1: false,
      daily_lobby_msg_2: false,
      daily_lobby_msg_3: false,
      avatar_changed: false,
      name_changed: false,
      description_changed: false,
      ens_name_changed: false,
      multiplier: 1,
      today_points: 0,
      today_max_points: 0,
      is_spam_user: false,
    },
    isLoading: !error && !data,
    isError: error,
  };
};

export default useReward;
